module.exports = __webpack_public_path__ + "img/46111f9.jpg";